import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from '@shared/domain';

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  mode: 'demo' | 'jwt';
  setUser: (user: AuthUser | null, token: string | null) => void;
  setMode: (mode: 'demo' | 'jwt') => void;
  logout: () => void;
}

/** Global auth store. Token is persisted so a page refresh keeps the session. */
export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      mode: 'demo',
      setUser: (user, token) => set({ user, token }),
      setMode: (mode) => set({ mode }),
      logout: () => set({ user: null, token: null }),
    }),
    { name: 'ras-auth' },
  ),
);

export function getToken(): string | null {
  return useAuth.getState().token;
}
